import React from "react";

export const Values = (props) => {
  return (
    <div id="values">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6" style={{ marginBottom: "30px" }}>
            {" "}
            <img src="img/tapetointi.jpg" className="img-responsive" alt="" />{" "}
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>Arvot</h2>
              <h3>Asiakaslähtöisyys</h3>
              <p>{props.data ? props.data.first : "loading..."}</p>
              <h3>Vastuullisuus</h3>
              <div>{props.data ? props.data.second.map((d, i) => <p key={`${d}-${i}`}>{d}</p>) : "loading..."}</div>
              <h3>Luotettavuus</h3>
              <p>{props.data ? props.data.third : "loading..."}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
